import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageManagerService, SettingsService, CompanyContactService, LLFormService } from '../services/index';
import { ProductDashboardService } from '../services/product-dashboard.service';

@Injectable()
export class ProductDashboardResolverService implements Resolve<any> {
  revisionId: number | undefined;
  customerGuid: string | undefined;

  constructor(private storageManagerService: StorageManagerService, private settingsService: SettingsService,
              private productDashboardService: ProductDashboardService,
              private companyService: CompanyContactService,
              private llService: LLFormService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (!isNaN(route.params.revisionId)) {
      this.revisionId = parseInt(route.params.revisionId, 10);
    }

    this.customerGuid = this.settingsService.getCustomerGuid();
    const modifiedByUser = this.settingsService.getUserDataName();

    const retVal = forkJoin([
        this.revisionId ? this.productDashboardService.getProductDashboard(this.revisionId) : of(null),
        this.companyService.getBusinessCategories(false),
        this.llService.getRevisionHistory(this.revisionId)]
    )
    .pipe(catchError(err => of({ error: err })));

    return retVal;
  }
}
